/* import __COLOCATED_TEMPLATE__ from './io-voltage-drift.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();